export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4763.e10eba90.jpg";